<!-- cxone modal -->
<div *ngIf="isCXOne" class="cx-one-ui"><!-- Parent that resizes with the ngbModal, but the child will have min sizes with overflow scroll -->
    <cv-loader [hidden]="!isLoading" size="large" [overlay]="true"></cv-loader>
    <div class="modal-header cxone-modal-header">
        <div class="agentStatus cxone-details-header">
            <div class="modal-title cxone-details-title mr-1" cvLocalizedText langSection="Agent_State_Details" langKey="CXone_Modal_Title">Agent State Details</div>
        </div>
        <div class="modal-close">
            <button type="button" class="icon-btn fill-iconDefault" (click)="close()">
                <svg class="icon-12">
                    <use href="../../App_Themes/CXone/icons/close.svg#close"></use>
                </svg>
            </button>
        </div>       
    </div>
        <!-- Body Section -->
        <div class="modal-body cxone-modal-body">
            <div class="cxone-details-top">
                <div class="cxone-agent-container">
                    <div class="cxoneAgentPicture"><img [attr.src]="agent.profilePicturePath" onerror="this.src='../Admin/ImageResizer.aspx?imgid=-2&w=56&h=56'"/></div>
                    <div class="agentName cxone-agent-name">{{agent.name}}</div>
                </div>
                <sol-datepicker
                    [(ngModel)]="selectedDate"
                    (ngModelChange)="onDatePickerChanged()"
                    [showActionArrows]="false"
                    [displayFooter]="false"
                    [noLabel]="true">
                </sol-datepicker>
            </div>
            <div class="cxone-details-table">
                <div class="cxone-state-table">
                    <div class="stateHistoryTable currentAgentStatesTableView">
                        <div class="grid-container ag-theme-balham ng-scope">
                            <ag-grid-angular 
                                #agentStateDetailGrid
                                *ngIf="gridOptions != null"
                                class="ag-theme-balham flex-fill grid-container"
                                [gridOptions]="gridOptions">
                            </ag-grid-angular>
                        </div>
                    </div>
                </div>

                <div class="cxone-state-details">
                    <div class="cxone-summary-container">
                        <div class="cxone-summary-title" cvLocalizedText langSection="Agent_State_Details" langKey="CXone_Header_Summary">Summary</div>
                        <div [hidden]="!noData" class="right-error-container">
                            <svg class="error-icon">
                                <use href="../App_Themes/CXone/icons/empty.svg#empty"></use>
                            </svg>
                            <p class="cxone-error-text" cvLocalizedText langSection="Agent_State_Details" langKey="CXone_Data_Error">No data available</p>
                        </div>
                        <div [hidden]="noData" class="cxone-summary-chart">

                            <!-- Inbound -->
                            <div class="cxone-state-row">
                                <div class="cxone-state-text">
                                    <div class="cxone-state-category" [hidden]="!agentStateCategoriesReady" title="{{agentStateCategories.Inbound}}">{{agentStateCategories.Inbound}}</div>
                                    <div class="cxone-state-time">{{getStateSummaryFormatted('Inbound')}}</div>
                                </div>
                                <div class="cxone-state-bar-container">
                                    <div class="cxone-state-bar inbound" [ngStyle]="{width: getStateSummaryPercentage('Inbound')}">
                                        <span class="cxone-state-bar-text">
                                            {{(stateSummary['Inbound'] === null) ? '0.5%' : getStateSummaryPercentage('Inbound') }}
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <!-- Outbound -->
                            <div class="cxone-state-row">
                                <div class="cxone-state-text">
                                    <div class="cxone-state-category" [hidden]="!agentStateCategoriesReady" title="{{agentStateCategories.Outbound}}">{{agentStateCategories.Outbound}}</div>
                                    <div class="cxone-state-time">{{getStateSummaryFormatted('Outbound')}}</div>
                                </div>
                                <div class="cxone-state-bar-container">
                                    <div class="cxone-state-bar outbound" [ngStyle]="{width: getStateSummaryPercentage('Outbound')}">
                                        <span class="cxone-state-bar-text">
                                            {{(stateSummary['Outbound'] === null) ? '0.5%' : getStateSummaryPercentage('Outbound') }}
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <!-- Available -->
                            <div class="cxone-state-row">
                                <div class="cxone-state-text">
                                    <div class="cxone-state-category" [hidden]="!agentStateCategoriesReady" title="{{agentStateCategories.Available}}">{{agentStateCategories.Available}}</div>
                                    <div class="cxone-state-time">{{getStateSummaryFormatted('Available')}}</div>
                                </div>
                                <div class="cxone-state-bar-container">
                                    <div class="cxone-state-bar available" [ngStyle]="{width: getStateSummaryPercentage('Available')}">
                                        <span class="cxone-state-bar-text">
                                            {{(stateSummary['Available'] === null) ? '0.5%' : getStateSummaryPercentage('Available') }}
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <!-- Unavailable -->
                            <div class="cxone-state-row">
                                <div class="cxone-state-text">
                                    <div class="cxone-state-category" [hidden]="!agentStateCategoriesReady" title="{{agentStateCategories.Unavailable}} {{totalLabel}}">{{agentStateCategories.Unavailable}} {{totalLabel}}</div>
                                    <div class="cxone-state-time">{{getStateSummaryFormatted('Unavailable')}}</div>
                                </div>
                                <div class="cxone-state-bar-container">
                                    <div class="cxone-state-bar unavailable" [ngStyle]="{width: getStateSummaryPercentage('Unavailable')}">
                                        <span class="cxone-state-bar-text">
                                            {{(stateSummary['Unavailable'] === null) ? '0%' : getStateSummaryPercentage('Unavailable') }}
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <!-- ACW -->
                            <div class="cxone-state-row">
                                <div class="cxone-state-text">
                                    <div class="cxone-state-category" [hidden]="!agentStateCategoriesReady" title="{{agentStateCategories.ACW}}">{{agentStateCategories.ACW}}</div>
                                    <div class="cxone-state-time">{{getStateSummaryFormatted('ACW')}}</div>
                                </div>
                                <div class="cxone-state-bar-container">
                                    <div class="cxone-state-bar acw" [ngStyle]="{width: getStateSummaryPercentage('ACW')}">
                                        <span class="cxone-state-bar-text">
                                            {{(stateSummary['ACW'] === null) ? '0.5%' : getStateSummaryPercentage('ACW') }}
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <!-- Logged In -->
                            <div class="cxone-state-row">
                                <div class="cxone-state-text">
                                    <div class="cxone-state-category" [hidden]="!agentStateCategoriesReady" title="{{agentStateCategories.LoggedIn}}">{{agentStateCategories.LoggedIn}}</div>
                                    <div class="cxone-state-time">{{getStateSummaryFormatted('LoggedIn')}}</div>
                                </div>
                                <div class="cxone-state-bar-container">
                                    <div class="cxone-state-bar loggedin" [ngStyle]="{width: getStateSummaryPercentage('LoggedIn')}">
                                        <span class="cxone-state-bar-text">
                                            {{(stateSummary['LoggedIn'] === null) ? '0.5%' : getStateSummaryPercentage('LoggedIn') }}
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <!-- Logged Out -->
                            <div class="cxone-state-row">
                                <div class="cxone-state-text">
                                    <div class="cxone-state-category" [hidden]="!agentStateCategoriesReady" title="{{agentStateCategories.LoggedOut}}">{{agentStateCategories.LoggedOut}}</div>
                                    <div class="cxone-state-time">{{getStateSummaryFormatted('LoggedOut')}}</div>
                                </div>
                                <div class="cxone-state-bar-container">
                                    <div class="cxone-state-bar loggedout" [ngStyle]="{width: getStateSummaryPercentage('LoggedOut')}">
                                        <span class="cxone-state-bar-text">
                                            {{(stateSummary['LoggedOut'] === null) ? '0.5%' : getStateSummaryPercentage('LoggedOut') }}
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <!-- Dialer -->
                            <div class="cxone-state-row">
                                <div class="cxone-state-text">
                                    <div class="cxone-state-category" [hidden]="!agentStateCategoriesReady" title="{{agentStateCategories.Dialer}}">{{agentStateCategories.Dialer}}</div>
                                    <div class="cxone-state-time">{{getStateSummaryFormatted('Dialer')}}</div>
                                </div>
                                <div class="cxone-state-bar-container">
                                    <div class="cxone-state-bar dialer" [ngStyle]="{width: getStateSummaryPercentage('Dialer')}">
                                        <span class="cxone-state-bar-text">
                                            {{(stateSummary['Dialer'] === null) ? '0.5%' : getStateSummaryPercentage('Dialer') }}
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <!-- Unavailable Substates -->
                            <div class="cxone-state-row" *ngFor=" let subState of stateSummary.UnavailableSubStates; let i = index">
                                <div class="cxone-state-text">
                                    <div class="cxone-state-category textTruncate" title="{{ subState.name }}">{{ subState.name }}</div>
                                    <div class="cxone-state-time">{{ getSubStateSummaryFormatted(i) }}</div>
                                </div>
                                <div class="cxone-state-bar-container">
                                    <div class="cxone-state-bar unavailable" [ngStyle]="{width: getSubStateSummaryPercentage(i)}">
                                        <span class="cxone-state-bar-text">
                                            {{ getSubStateSummaryPercentage(i) }}
                                        </span>
                                    </div>
                                </div>
                                <div class="statePercentageText"></div>
                            </div> <!-- Unavailable Substates -->
                        </div> <!-- summary chart -->
                    </div> <!-- summary container -->
                </div> <!-- section right -->
            </div> <!-- details table -->
        </div> <!-- body content -->
        <div class="modal-footer cxone-modal-footer">    
            <button type="button" class="cxone-btn btn modal-footer-btn btn-primary" cvLocalizedText langSection="Agent_State_Details" langKey="Close" (click)="close()">Close</button>
        </div>
</div> <!-- modal parent -->

<!-- default modal -->
<div *ngIf="!isCXOne" class="h-100 w-100" style="overflow-y: auto"><!-- Parent that resizes with the ngbModal, but the child will have min sizes with overflow scroll -->
    <div class="moduleDialogWindow d-flex flex-column justify-content-between" style="height: 550px">
        <!-- Close button -->
        <div class="position-absolute" style="top: 8px; right: 8px;">
            <button type="button" class="icon-btn fill-valyrianSteel fill-hover-whaleTail" (click)="close()">
                <svg class="icon-16">
                    <use href="../../App_Themes/clearview-default/icons/utility/close.svg#close"></use>
                </svg>
            </button>
        </div>

        <!-- Title Section -->
        <div class="titleBar w-100">
            <div class="agentPicture"><img [attr.src]="agent.profilePicturePath" onerror="this.src='../Admin/ImageResizer.aspx?imgid=-2&w=56&h=56'"/></div>
            <div class="agentName">{{agent.name}}</div>
            <div class="agentStatus mr-auto">
                <div class="statusText" [ngStyle]="{color: getStateColor(agent.currentState)}">{{ agent.currentState.displayState }}</div>
                <div class="statusTime">{{agent.stateStartTime}}</div>
            </div>
            <!-- export button -->
            <button type="button" class="btn btn-icon btn-text font-size-14 my-auto mr-1"
                    style="min-height: 20px;"
                    (click)="exportClicked('excel')">
                <svg class="fill-cerulean">
                    <use href="../App_Themes/clearview-default/icons/utility/export.svg#export"></use>
                </svg>
                {{exportLabel}}
            </button>
        </div>


        <!-- Body Section -->
        <div class="bodyContent h-100 w-100 justify-content-between py-3 px-4">
            <div class="sectionLeft h-auto m-0" style="width: 600px">
                <div class="position-relative stateHistoryTable currentAgentStatesTableView">
                    <cv-loader [hidden]="!isLoading" size="large" [overlay]="true"></cv-loader>
                    <div class="grid-container ag-theme-balham h-100 ng-scope" style="margin: 0 -32; min-width: 600px;">
                        <ag-grid-angular 
                            #agentStateDetailGrid
                            *ngIf="gridOptions != null"
                            class="ag-theme-balham flex-fill h-100 grid-container"
                            [gridOptions]="gridOptions"
                            style="height:100%; width:100%;">
                        </ag-grid-angular>
                    </div>
                </div>
            </div>

            <div class="sectionRight" style="width: 340px">
                <div class="dateContainer mt-3">
                    <cv-baremetrics-calendar
                        class="d-block daterange daterange--single" 
                        [(currentDate)]="selectedDate"
                        (dateChanged)="onDatePickerChanged()"
                        [required]="true"
                    ></cv-baremetrics-calendar>
                </div>

                <div class="updatedText"><span cvLocalizedText langSection="Agent_State_Details" langKey="Updated">Updated:</span> {{ updatedTime }}</div>

                <div class="summaryContainer">
                    <div class="stateSummaryTitle" cvLocalizedText langSection="Agent_State_Details" langKey="Header_Summary">State Summary</div>
                    <div class="summaryChart">

                        <!-- Inbound -->
                        <div class="stateRow bottomBorder">
                            <div class="stateText">
                                <div class="stateCategory" [hidden]="!agentStateCategoriesReady" title="{{agentStateCategories.Inbound}}">{{agentStateCategories.Inbound}}</div>
                                <div class="stateTime">{{getStateSummaryFormatted('Inbound')}}</div>
                            </div>
                            <div class="stateBarContainer">
                                <div class="stateBar inbound" [ngStyle]="{width: getStateSummaryPercentage('Inbound')}"></div>
                            </div>
                            <div class="statePercentageText">{{(stateSummary['Inbound'] === null) ? '0.5%' : getStateSummaryPercentage('Inbound') }}</div>
                        </div>

                        <!-- Outbound -->
                        <div class="stateRow">
                            <div class="stateText">
                                <div class="stateCategory" [hidden]="!agentStateCategoriesReady" title="{{agentStateCategories.Outbound}}">{{agentStateCategories.Outbound}}</div>
                                <div class="stateTime">{{getStateSummaryFormatted('Outbound')}}</div>
                            </div>
                            <div class="stateBarContainer">
                                <div class="stateBar outbound" [ngStyle]="{width: getStateSummaryPercentage('Outbound')}"></div>
                            </div>
                            <div class="statePercentageText">{{(stateSummary['Outbound'] === null) ? '0.5%' : getStateSummaryPercentage('Outbound') }}</div>
                        </div>

                        <!-- Available -->
                        <div class="stateRow bottomBorder">
                            <div class="stateText">
                                <div class="stateCategory" [hidden]="!agentStateCategoriesReady" title="{{agentStateCategories.Available}}">{{agentStateCategories.Available}}</div>
                                <div class="stateTime">{{getStateSummaryFormatted('Available')}}</div>
                            </div>
                            <div class="stateBarContainer">
                                <div class="stateBar available" [ngStyle]="{width: getStateSummaryPercentage('Available')}"></div>
                            </div>
                            <div class="statePercentageText">{{(stateSummary['Available'] === null) ? '0.5%' : getStateSummaryPercentage('Available') }}</div>
                        </div>

                        <!-- Unavailable -->
                        <div class="stateRow bottomBorder">
                            <div class="stateText">
                                <div class="stateCategory" [hidden]="!agentStateCategoriesReady" title="{{agentStateCategories.Unavailable}} {{totalLabel}}">{{agentStateCategories.Unavailable}}  {{totalLabel}}</div>
                                <div class="stateTime">{{getStateSummaryFormatted('Unavailable')}}</div>
                            </div>
                            <div class="stateBarContainer">
                                <div class="stateBar unavailable" [ngStyle]="{width: getStateSummaryPercentage('Unavailable')}"></div>
                            </div>
                            <div class="statePercentageText"> {{(stateSummary['Unavailable'] === null) ? '0%' : getStateSummaryPercentage('Unavailable')}}</div>
                        </div>

                        <!-- ACW -->
                        <div class="stateRow bottomBorder">
                            <div class="stateText">
                                <div class="stateCategory" [hidden]="!agentStateCategoriesReady" title="{{agentStateCategories.ACW}}">{{agentStateCategories.ACW}}</div>
                                <div class="stateTime">{{getStateSummaryFormatted('ACW')}}</div>
                            </div>
                            <div class="stateBarContainer">
                                <div class="stateBar acw" [ngStyle]="{width: getStateSummaryPercentage('ACW')}"></div>
                            </div>
                            <div class="statePercentageText">{{(stateSummary['ACW'] === null) ? '0.5%' : getStateSummaryPercentage('ACW') }}</div>
                        </div>

                        <!-- Logged In -->
                        <div class="stateRow bottomBorder">
                            <div class="stateText">
                                <div class="stateCategory" [hidden]="!agentStateCategoriesReady" title="{{agentStateCategories.LoggedIn}}">{{agentStateCategories.LoggedIn}}</div>
                                <div class="stateTime">{{getStateSummaryFormatted('LoggedIn')}}</div>
                            </div>
                            <div class="stateBarContainer">
                                <div class="stateBar loggedin" [ngStyle]="{width: getStateSummaryPercentage('LoggedIn')}"></div>
                            </div>
                            <div class="statePercentageText">{{(stateSummary['LoggedIn'] === null) ? '0.5%' : getStateSummaryPercentage('LoggedIn') }}</div>
                        </div>

                        <!-- Logged Out -->
                        <div class="stateRow bottomBorder">
                            <div class="stateText">
                                <div class="stateCategory" [hidden]="!agentStateCategoriesReady" title="{{agentStateCategories.LoggedOut}}">{{agentStateCategories.LoggedOut}}</div>
                                <div class="stateTime">{{getStateSummaryFormatted('LoggedOut')}}</div>
                            </div>
                            <div class="stateBarContainer">
                                <div class="stateBar loggedout" [ngStyle]="{width: getStateSummaryPercentage('LoggedOut')}"></div>
                            </div>
                            <div class="statePercentageText">{{(stateSummary['LoggedOut'] === null) ? '0.5%' : getStateSummaryPercentage('LoggedOut') }}</div>
                        </div>

                        <!-- Dialer -->
                        <div *ngIf="shouldIncludeDialer()" class="stateRow bottomBorder">
                            <div class="stateText">
                                <div class="stateCategory" [hidden]="!agentStateCategoriesReady" title="{{agentStateCategories.Dialer}}">{{agentStateCategories.Dialer}}</div>
                                <div class="stateTime">{{getStateSummaryFormatted('Dialer')}}</div>
                            </div>
                            <div class="stateBarContainer">
                                <div class="stateBar dialer" [ngStyle]="{width: getStateSummaryPercentage('Dialer')}"></div>
                            </div>
                            <div class="statePercentageText">{{(stateSummary['Dialer'] === null) ? '0.5%' : getStateSummaryPercentage('Dialer') }}</div>
                        </div>

                        <!-- Unavailable Substates -->
                        <div class="stateRow bottomBorder" *ngFor=" let subState of stateSummary.UnavailableSubStates; let i = index">
                            <div class="stateText">
                                <div class="stateCategory textTruncate" title="{{ subState.name }}">{{ subState.name }}</div>
                                <div class="stateTime">{{ getSubStateSummaryFormatted(i) }}</div>
                            </div>
                            <div class="stateBarContainer">
                                <div class="stateBar unavailable" [ngStyle]="{width: getSubStateSummaryPercentage(i)}"></div>
                            </div>
                            <div class="statePercentageText">{{ getSubStateSummaryPercentage(i) }}</div>
                        </div> <!-- Unavailable Substates -->
                    </div> <!-- summary chart -->
                    <div class="durationAsteriskNote" cvLocalizedText langSection="Agent_State_Details" langKey="Duration_Disclaimer">*Duration is reflected in the previous or next day.</div>
                </div> <!-- summary container -->
            </div> <!-- section right -->
        </div> <!-- body content -->
    </div>
</div> <!-- modal parent -->

